<style lang="scss" scoped>
.emphasis {
  font-weight: bold;
}
</style>

<template>
  <c-layout>
    <!-- title -->
    <template #title>
      <div>Diode: <span>{{serial}}</span></div>
    </template>

    <template #content>
      <div class="columns">
        <!-- diode information -->
        <div class="column is-size-6">
          <div><span class="emphasis is-family-monospace">
            Serial: </span> {{diode.serial}}
          </div>
          <div><span class="emphasis is-family-monospace">
            Name: </span> {{diode.name | ifndef('-')}}
          </div>
          <div><span class="emphasis is-family-monospace">
            User: </span> {{diode.user ? diode.user.email : '-'}}
          </div>
        </div>
        <div class="column">
          <div><span class="emphasis is-family-monospace">
            Location: </span> {{diode.location | ifndef('-')}}
          </div>
          <div><span class="emphasis is-family-monospace">
            Last Event: </span> {{diode.heartbeat | time | relative | ifndef('-')}}
          </div>
        </div>
      </div>

      <div class="columns">
        <!-- event stream -->
        <div class="column is-half">
          <div class="heading">Events</div>
          <div v-if="unassigned" class="text has-text-centered has-text-warning has-background-dark">
            Warning: Current event stream is only available for diodes assigned to a user.
          </div>
          <stream :events="poller.events"/>
        </div>

        <!-- telemetry stream -->
        <div class="column is-half">
          <div class="heading">Telemetry</div>
          <stream :events="telemetry.events"/>
        </div>
      </div>
    </template>

  </c-layout>
</template>

<script>
import api from '@/api';
import Diode from '@/models/diode';
import Poller from '@/utils/poller';
import Stream from '@/components/stream';


export default {
  name: 'manage-diode',
  components: {
    Stream
  },
  data() {
    return {
      poller: new Poller({
        retrieve: async (position) => {
          if (!this.serial || this.user === undefined) return [];
          return api.admin.events.index(this.user, this.serial, {
            after: position,
            limit: 100
          });
        }
      }),
      telemetry: new Poller({
        retrieve: async (position) => {
          if (!this.serial) return [];
          return api.admin.telemetry.index(this.serial, {
            after: position,
            limit: 100
          });
        }
      })
    };
  },
  computed: {
    diode() {
      return Diode.find(this.$route.params.serial) || {};
    },
    user() {
      return (this.diode.user && this.diode.user.id) || undefined;
    },
    serial() {
      return this.diode.serial;
    },
    unassigned() {
      return this.serial && this.user === undefined;
    }
  },
  created() {
    this.poller.start();
    this.telemetry.start();
  },
  destroyed () {
    this.poller.stop();
    this.telemetry.stop();
  }
};
</script>
